import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ListGroup } from 'reactstrap';
import TwoDimensionalImageContext from '../TwoDimensionalImage/twoDimensionalImageContext';
// import OptionItem from './OptionItem/OptionItem.jsx';
// import 'bootstrap/dist/css/bootstrap.css';
import '../../../../../../../../assets/css/twoDimensionalImageBoostrap.css';
import './optionList.scss';

import { MenuItem, TextField} from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';

const OptionList = ({
	className,
	annotationName,
	ancestorOptionIds,
	selectedOptions,
	level,
}) => {
	// const [value, setValue] = useState('');
	const twoDimensionalImageContext = useContext(TwoDimensionalImageContext);
	const {
		entities: { options, annotations },
		// isDynamicOptionsEnable,
		// onOptionCustomizedInputFocus,
		// onOptionCustomizedInputBlur,
		// onOptionCustomizedFormSubmit,
	} = twoDimensionalImageContext;

    console.log('optionsList options', options)

	const parentOptionId = ancestorOptionIds[ancestorOptionIds.length - 1];
	console.log('parentOptionId', parentOptionId)
	
	/*
	const itemListUI = options[parentOptionId].children.map((optionId) => {
		const childrenOptionIds = options[optionId].children;
		return (
			<OptionItem
				key={ optionId }
				level={ level }
				ancestorOptionIds={ [...ancestorOptionIds, optionId] }
				optionId={ optionId }
				childrenOptionIds={ childrenOptionIds }
				annotationName={ annotationName }
				selectedOptions={ selectedOptions }
			/>
		);
	});
	*/
	



	const SelectLabelDropdown = 
	React.memo(
		({
			annotationName,
			optionIds,
			options,
			annotations,
			twoDimensionalImageContext
		}) => {

			const {
			onOptionSelect,
			handleAllowAnyAnnotationLabelOptionSelect,
			allowUserToSetAnyLabelForImageAnnotation,
			// onOptionCustomizedFormSubmit,
				isViewOnlyMode
			} = twoDimensionalImageContext;
	
			const [optionsArray, setOptionsArray] = useState([]);
			const [selectedValue, setSelectedValue] = useState("");
	
			useEffect(()=>{
				const optionsArrayToUpdate = [];
				for (let index = 0; index < Object.keys(options).length; index++) {
					
					//** @type {number} */
					const objectId = Object.keys(options)[index];
					
					// const object = options[index];
					const object = options[objectId];				
	
	
					if (object.id === '0') {
						continue;
					}
					optionsArrayToUpdate.push(object);
				}
				setOptionsArray(optionsArrayToUpdate);
			}, [options])
	
			useEffect(()=>{
				if (Object.keys(annotations).length>0) {
					for (let index = 0; index < Object.keys(annotations).length; index++) {
						const annotationObject = annotations[Object.keys(annotations)[index]];
						if (annotationObject.name === annotationName) {
							for (const selectedOption of annotationObject.selectedOptions) {
								if (selectedOption.id === "0") {
									continue;
								}
								if(allowUserToSetAnyLabelForImageAnnotation){
									setSelectedValue(selectedOption.value || "")
								}
								else {
									setSelectedValue(selectedOption.id || "")
								}
							}
						}
					}
				}
			}, [annotations, annotationName])
			console.log("testing selectedValue", selectedValue)

			return (
				<>
					{
						allowUserToSetAnyLabelForImageAnnotation?
						<Autocomplete
						id="image-annotation-label-autocomplete"
						options={optionsArray.map((option) => option.value)}
						style={{ width: 300 }}
						freeSolo
						value={selectedValue.toString()}
						onBlur={(event) => {
							const value = event.target.value;
							handleAllowAnyAnnotationLabelOptionSelect(annotationName, ["0"], value)
						}}
						onChange={(event) => {
							const value = event.target.value;
							console.log("testing change", event.target.value)
							const selectedId = optionsArray.find(option => option.value===value)?.id
							if(selectedId) {
								onOptionSelect(annotationName, ["0", selectedId])
							}
						}}
						renderInput={(params) => 
						<TextField {...params} 
						id="select-text-field"
						label="Select"
						// select
						disabled={isViewOnlyMode}
						helperText="Please select annotation label"
						 />}
					/>
					:
							<TextField
								id="image-annotation-label-autocomplete-textfield"
								select
								label="Select"
								value={selectedValue}
								disabled={isViewOnlyMode}
								onChange={(event) => {
									const value = event.target.value;

									// const option = optionsArray.filter(option.id === value)[0];
									// console.log('option', option)

									// console.log('parentOptionId',parentOptionId); 
									// onOptionCustomizedFormSubmit(event, parentOptionId, value);
									onOptionSelect(annotationName, ["0", value])
								}}
								helperText="Please select annotation label"
							>
								{
									optionsArray
										.map((option) => (
											<MenuItem key={option.id} value={option.id}>
												{option.value}
											</MenuItem>
										))}

							</TextField>
				}
				</>
			)
	
			// return (
			// 	<TextField
			// 	id="standard-select-currency"
			// 	select
			// 	label="Select"
			// 	value={selectedValue}
			// 	disabled={isViewOnlyMode}
			// 	onChange={(event)=>{
			// 		const value = event.target.value;
	
			// 		// const option = optionsArray.filter(option.id === value)[0];
			// 		// console.log('option', option)
	
			// 		// console.log('parentOptionId',parentOptionId); 
			// 		// onOptionCustomizedFormSubmit(event, parentOptionId, value);
			// 		onOptionSelect(annotationName, ["0", value])
			// 	}}
			// 	helperText="Please select annotation label"
			// >
			// 	{
			// 	optionsArray
			// 	.map((option) => (
			// 		<MenuItem key={option.id} value={option.id}>
			// 			{option.value}
			// 		</MenuItem>
			// 	))}
				
			// </TextField>
			
			// );
		}
	);

/*
	const customizedOptionUI = isDynamicOptionsEnable ? (
		<ListGroupItem key={ `customized-${parentOptionId}` } style={ { paddingLeft: 30 * level } }>
			<Form inline 
				onSubmit={ (e) => { 
				onOptionCustomizedFormSubmit(e, parentOptionId, value); 
				} }
			>
				<Input
					className='mr-sm-2'
					type='text'
					name={ parentOptionId }
					value={ value }
					onFocus={ onOptionCustomizedInputFocus }
					onBlur={ onOptionCustomizedInputBlur }
					onChange={ e => setValue(e.target.value) }
				/>
				<Input type='submit' value='Submit' className='my-2 my-sm-0' />
			</Form>
		</ListGroupItem>
	) : null;
*/
	const rootClassName = `option-list${className ? ` ${className}` : ''}`;
	return (
		<ListGroup className={ rootClassName }>
			{/* { itemListUI }  */}
			 {/* { customizedOptionUI } */}
			 {
				 options &&
				 <SelectLabelDropdown 
					 annotationName={annotationName}
					 optionIds={[...ancestorOptionIds, parentOptionId]}
					 options={options}
					 annotations={annotations}
					 twoDimensionalImageContext={twoDimensionalImageContext}
				 /> 
			 }
		</ListGroup>
	);
};

OptionList.propTypes = {
	className: PropTypes.string,
	annotationName: PropTypes.string,
	level: PropTypes.number,
	ancestorOptionIds: PropTypes.arrayOf(PropTypes.string),
	selectedOptions: PropTypes.arrayOf(PropTypes.object),
};
OptionList.defaultProps = {
	className: '',
	annotationName: '',
	level: 1,
	ancestorOptionIds: [],
	selectedOptions: [],
};
export default React.memo(OptionList);
